<div class="form-group">
  <mat-form-field class="example-full-width" appearance="fill">
  <mat-label >{{field.templateOptions.label}}</mat-label>
  <input matInput type="password" [formControl]="formControl" [formlyAttributes]="field" placeholder="Mot de passe" autocomplete="new-password">
 </mat-form-field>
</div>
